import React from "react";
import { pSBC, lightOrDark } from "../../utils/newShade";
import { CSS_ENDPOINT } from "../../utils/constants";

export default function styleSetter({ client }) {
  if (!client) {
    return null;
  }

  return (
    <>
      {client.primaryColor && (
        <style
          dangerouslySetInnerHTML={{
            __html: ` :root {
                --primary-color: ${client.primaryColor};
                --primary-color-darken: ${pSBC(-0.4, client.primaryColor)};
                --primary-color-lighter: ${pSBC(0.3935, client.primaryColor)};
                }`,
          }}
        />
      )}
      {client.secondaryColor && (
        <style
          dangerouslySetInnerHTML={{
            __html: ` :root {
                --secondary-color: ${client.secondaryColor}
                }`,
          }}
        />
      )}
      {client.primaryTextColor && (
        <style
          dangerouslySetInnerHTML={{
            __html: ` :root {
              --primary-text-color: ${client.primaryTextColor};
              --primary-text-color-shade: ${
                lightOrDark(client.primaryTextColor) === "dark"
                  ? pSBC(0.3935, client.primaryTextColor)
                  : pSBC(-0.4, client.primaryTextColor)
              };
              --primary-text-color-opposite-shade: ${
                lightOrDark(client.primaryTextColor) === "dark"
                  ? pSBC(-0.4, client.primaryTextColor)
                  : pSBC(0.3935, client.primaryTextColor)
              };
              --primary-text-color-opposite-shade-shadow: ${
                lightOrDark(client.primaryTextColor) === "dark"
                  ? pSBC(0.787, client.primaryTextColor)
                  : pSBC(-0.937, client.primaryTextColor)
              };
                }`,
          }}
        />
      )}
      {client.secondaryTextColor && (
        <style
          dangerouslySetInnerHTML={{
            __html: ` :root {
              --secondary-text-color: ${client.secondaryTextColor};
              --secondary-text-color-shade: ${
                lightOrDark(client.secondaryTextColor) === "dark"
                  ? pSBC(0.3935, client.secondaryTextColor)
                  : pSBC(-0.4, client.secondaryTextColor)
              };
              --secondary-text-color-opposite-shade: ${
                lightOrDark(client.secondaryTextColor) === "dark"
                  ? pSBC(-0.4, client.secondaryTextColor)
                  : pSBC(0.3935, client.secondaryTextColor)
              };
                }`,
          }}
        />
      )}
      {client.bgColor && (
        <style
          dangerouslySetInnerHTML={{
            __html: ` :root {
              --bg-color: ${client.bgColor};
              --bg-color-shade: ${
                lightOrDark(client.bgColor) === "dark" ? pSBC(0.3935, client.bgColor) : pSBC(-0.4, client.bgColor)
              };
              --bg-color-opposite-shade: ${
                lightOrDark(client.bgColor) === "dark" ? pSBC(-0.9, client.bgColor) : pSBC(0.8935, client.bgColor)
              };
                }`,
          }}
        />
      )}
      {client.altColor && (
        <style
          dangerouslySetInnerHTML={{
            __html: ` :root {
              --alt-color: ${client.altColor};
                }`,
          }}
        />
      )}
      {client.cssURL && (
        <link rel="stylesheet" href={`${CSS_ENDPOINT}${client.cssURL}`} type="text/css" media="all"></link>
      )}
    </>
  );
}
